import React from 'react';
import Header from '../../../components/header';
// import WaveDivider from '../../../components/wave-divider';
import WaveBg from '../../../components/wave-background';
import SubsidiaryCard from './subsidiary-card';

import { useLanguage } from '../../../helpers/language-context';
import { renderHTML } from '../../../helpers/render-html';

const Subsidiary = () => {
  const { translations } = useLanguage();
  return (
    <div className="services-container">
      <Header title={translations.services.subsidiaryCompany} flip={true} bgImg="/assets/images/header-bg/bg_subsidiaries_new.jpg" color="#F2F2F2" />
      <section className="bg-[#F2F2F2]">
        <div className="relative z-10 flex flex-col space-y-4 text-center justify-center items-center mx-auto mb-16">
          <div className="md:max-w-[60%]">
            <h2 className="text-4xl md:text-5xl lg:text-6xl text-[#28357B] mb-4 md:mb-8">{translations.services.buildingSuccessThroughOurSubsidiaries}</h2>
          </div>
          <div className="space-y-2 md:max-w-[80%]">
            <p className="text-sm text-black" dangerouslySetInnerHTML={renderHTML(translations.services.subsidiaryDesc)} />
          </div>
        </div>

        <SubsidiaryCard />
        <div className="absolute left-0 w-full z-0 pointer-events-none">
          <WaveBg color='#28357B' flip={true} />
        </div>
      </section>
    </div>
  );
};

export default Subsidiary;
